import { CommunicationPageCreate } from "./communicationPageCreate";
import { CommunicationPageEdit } from "./communicationPageEdit";
import { CommunicationPageList } from "./communicationPageList";

export default {
	create: CommunicationPageCreate,
	edit: CommunicationPageEdit,
	list: CommunicationPageList,
};
